import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import coinIcon from 'assets/images/coin.svg'
import acceptInviteIcon from 'assets/images/profilepage-invite-accept.svg'
import refuseInviteIcon from 'assets/images/playroompage-cross.svg'
import friendStatus from 'assets/images/invite-friend-status.svg'
import { getListInvitationQuery, useAcceptInviteFriend } from 'dataLayer/user'
import { useQuery } from 'react-query'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'
import { useEffect, useState } from 'react'

function Invitation() {
	const { t } = useTranslation()
	const { data, isLoading } = useQuery(getListInvitationQuery(0, 10))
	const [loading, setLoading] = useState(false)
	const [listInvitation, setListInvitation] = useState([])
	// let listInvitation = (data && data.list_invitation) || []
	const _acceptFriendSucess = result => {
		setLoading(!loading)
	}
	useEffect(() => {
		if (data && data.list_invitation) {
			setListInvitation(data.list_invitation)
		} else {
			setListInvitation([])
		}
	}, [data])
	const { mutate } = useAcceptInviteFriend(_acceptFriendSucess)
	const handleAcceptFriend = dataSelect => {
		mutate({
			friend_id: dataSelect.friend_id,
			invitation_friend_id: dataSelect.id,
			is_accept: 1,
		})
		let newList = listInvitation.filter(it => it.id != dataSelect.id)
		setListInvitation(newList)
	}
	const handleRefuseFriend = dataSelect => {
		mutate({
			friend_id: dataSelect.friend_id,
			invitation_friend_id: dataSelect.id,
			is_accept: 0,
		})
		let newList = listInvitation.filter(it => it.id != dataSelect.id)
		setListInvitation(newList)
	}
	return (
		<>
			<Row className="profilepage-content__title">
				{t('profile.invitation.title')}
			</Row>
			<Row
				className="profilepage-content__body invitation header mt-3"
				style={{ height: 48, paddingBlock: 0, top: 0 }}
			>
				<Col xs={10}>{t('profile.invitation.name')}</Col>
				{/* <Col xs={4}>{t('profile.invitation.gold')}</Col> */}
			</Row>
			<Row className="profilepage-content__body invitation body mt-3 py-2">
				{listInvitation.length > 0 ? (
					listInvitation?.map(item => {
						return (
							<div key={item?.id} className="d-flex align-items-center py-2">
								<Col xs={10} className="friend-info">
									<div className="friend-info__ava me-2">
										<img src={item?.image} alt="Inviter's avatar" />
										{item.status === 1 ? (
											<img src={friendStatus} alt="Friend's status" />
										) : null}
									</div>
									<p>{item?.full_name}</p>
								</Col>
								{/* <Col xs={4} className="inviter-bet">
									<img src={coinIcon} alt="Bet's amount" />
									<p>{new Intl.NumberFormat('lo').format(item?.bet)}</p>
								</Col> */}
								<Col xs={2} className="inviter-interact">
									<img
										onClick={() => handleAcceptFriend(item)}
										src={acceptInviteIcon}
										alt="Accept invite"
									/>
									<img
										onClick={() => handleRefuseFriend(item)}
										src={refuseInviteIcon}
										alt="Refuse invite"
									/>
								</Col>
							</div>
						)
					})
				) : (
					<div className="container--img__no-data">
						<img
							className="img--no-data"
							src={noDataIcon}
							alt="No reward is found"
						/>
					</div>
				)}
			</Row>
		</>
	)
}

export default Invitation
